export const ADD_PROJECT = "ADD_PROJECT";
export const SELECT_PROJECT = "SELECT_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const CLEAR_ALL_PROJECTS = "CLEAR_ALL_PROJECTS";

export const UI_START_LOADING = "UI_START_LOADING";
export const UI_STOP_LOADING = "UI_STOP_LOADING";

export const ADD_PHOTO = "ADD_PHOTO";
export const UPLOAD_PHOTO = "UPLOAD_PHOTO";
export const CLEAR_PHOTOS = "CLEAR_PHOTOS";

export const SHOW_BAR = "SHOW_BAR";
export const HIDE_BAR = "HIDE_BAR";

export const EDIT_MODE_ON = "EDIT_MODE_ON";
export const EDIT_MODE_OFF = "EDIT_MODE_OFF";

export const SET_UI_FLAG = "SET_UI_FLAG";

export const LIST_PULL_REFRESHING_ON = "LIST_PULL_REFRESHING_ON";
export const LIST_PULL_REFRESHING_OFF = "LIST_PULL_REFRESHING_OFF";

export const SELECT_ID_TO_VIEW_PHOTOS = "SELECT_ID_TO_VIEW_PHOTOS";

export const ADD_RECORD = "ADD_RECORD";
export const ADD_ARRAY = "ADD_ARRAY";
export const ADD_SINGLE_RECORD = "ADD_SINGLE_RECORD";
export const DELETE_RECORD = "DELETE_RECORD";
export const SELECT_RECORD = "SELECT_RECORD";
export const INIT_SELECT_RECORD = "INIT_SELECT_RECORD";
export const UPDATE_RECORD = "UPDATE_RECORD";
export const CLEAR_ALL_RECORDS = "CLEAR_ALL_RECORDS";

export const TRY_AUTH = "TRY_AUTH";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const AUTH_REMOVE_TOKEN = "AUTH_REMOVE_TOKEN";

export const RESET_STORE = "RESET_STORE";

// / FIREBASE AUTH ACTIONS
export const LOGIN_WITH_PROVIDER_FIREBASE = "LOGIN_WITH_PROVIDER_FIREBASE";
export const REGISTER_FIREBASE_USER = "REGISTER_FIREBASE_USER";
export const LOGIN_FIREBASE_USER = "LOGIN_FIREBASE_USER";
export const FETCH_FIREBASE_USER = "FETCH_FIREBASE_USER";
export const UPDATE_FIREBASE_USER = "UPDATE_FIREBASE_USER";
export const CHANGE_FIREBASE_USER_PASSWORD = "CHANGE_FIREBASE_USER_PASSWORD";
export const FIREBASE_PASSWORD_RESET_EMAIL = "FIREBASE_PASSWORD_RESET_EMAIL";
export const LOGOUT_FIREBASE_USER = "LOGOUT_FIREBASE_USER";



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js